module.exports = (__webpack_require__(24))(6);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/classnames/index.js from dll-reference lib_core
// module id = 68
// module chunks = 107